"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _PanelItems = require("./components/PanelItems");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _Tabs = require("./components/gainsight/Tabs");

var _axios = _interopRequireDefault(require("axios"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GainsightIntegration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GainsightIntegration, _Component);

  var _super = _createSuper(GainsightIntegration);

  function GainsightIntegration(props) {
    var _props$isInstalled, _props$bucketPath, _props$accessKey, _props$securityToken, _props$isExportEnable, _props$bucketPath2, _props$accessKey2, _props$securityToken2;

    var _this;

    (0, _classCallCheck2.default)(this, GainsightIntegration);
    _this = _super.call(this, props);
    _this.state = {
      isInstalled: (_props$isInstalled = props.isInstalled) !== null && _props$isInstalled !== void 0 ? _props$isInstalled : false,
      activeTab: 0,
      showUnsavedChangesModal: false,
      showUninstallModal: false,
      bucketPath: (_props$bucketPath = props.bucketPath) !== null && _props$bucketPath !== void 0 ? _props$bucketPath : '',
      accessKey: (_props$accessKey = props.accessKey) !== null && _props$accessKey !== void 0 ? _props$accessKey : '',
      securityToken: (_props$securityToken = props.securityToken) !== null && _props$securityToken !== void 0 ? _props$securityToken : '',
      isExportEnabled: (_props$isExportEnable = props.isExportEnabled) !== null && _props$isExportEnable !== void 0 ? _props$isExportEnable : false,
      storedState: {
        bucketPath: (_props$bucketPath2 = props.bucketPath) !== null && _props$bucketPath2 !== void 0 ? _props$bucketPath2 : '',
        accessKey: (_props$accessKey2 = props.accessKey) !== null && _props$accessKey2 !== void 0 ? _props$accessKey2 : '',
        securityToken: (_props$securityToken2 = props.securityToken) !== null && _props$securityToken2 !== void 0 ? _props$securityToken2 : ''
      }
    };
    _this.setActiveTab = _this.setActiveTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedPanel = _this.setSelectedPanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.setActivePanel = _this.setActivePanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickUninstallButton = _this.onClickUninstallButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeUninstallModal = _this.closeUninstallModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.displayUnsavedChangedModal = _this.displayUnsavedChangedModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeValidationErrorFromInputField = _this.removeValidationErrorFromInputField.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetInstallationTab = _this.onResetInstallationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInstall = _this.onInstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUninstall = _this.onUninstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.dismissMessage = _this.dismissMessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(GainsightIntegration, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                window.addEventListener('beforeunload', function (e) {
                  return _this2.onUnload(e);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "onUnload",
    value: function onUnload(e) {
      if (this.checkPanelHasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }, {
    key: "onClickUninstallButton",
    value: function onClickUninstallButton() {
      this.setState({
        showUninstallModal: true
      });
    }
  }, {
    key: "closeUninstallModal",
    value: function closeUninstallModal() {
      this.setState({
        showUninstallModal: false
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state = this.state,
          bucketPath = _this$state.bucketPath,
          accessKey = _this$state.accessKey,
          securityToken = _this$state.securityToken,
          storedState = _this$state.storedState;
      var hasBucketPathChanged = bucketPath !== storedState.bucketPath;
      var hasAccessKeyChanged = accessKey !== storedState.accessKey;
      var hasSecurityTokenChanged = securityToken !== storedState.securityToken;
      return hasBucketPathChanged || hasAccessKeyChanged || hasSecurityTokenChanged;
    }
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        messageType: undefined,
        message: ''
      });
    }
  }, {
    key: "onInstall",
    value: function () {
      var _onInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$state2, bucketPath, accessKey, securityToken, validatedFields, successMessage, errorMessage, updatedStoredState, data, errorFields;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  errorFields: [],
                  isSavingCredentials: true
                });
                _this$state2 = this.state, bucketPath = _this$state2.bucketPath, accessKey = _this$state2.accessKey, securityToken = _this$state2.securityToken;
                validatedFields = [];

                if (bucketPath === '') {
                  validatedFields.push({
                    field: 'bucketAccessPath',
                    message: 'Please enter a bucket access path.'
                  });
                }

                if (accessKey === '') {
                  validatedFields.push({
                    field: 'accessKey',
                    message: 'Please enter an access key.'
                  });
                }

                if (securityToken === '') {
                  validatedFields.push({
                    field: 'securityToken',
                    message: 'Please enter a security token.'
                  });
                }

                if (!(validatedFields.length !== 0)) {
                  _context2.next = 9;
                  break;
                }

                this.setState({
                  errorFields: validatedFields,
                  isSavingCredentials: false
                });
                return _context2.abrupt("return");

              case 9:
                successMessage = 'All set! Gainsight installed.';
                errorMessage = "Something went wrong, credentials can't be saved. Please try again.";
                _context2.prev = 11;
                _context2.next = 14;
                return _axios.default.post('/integration/gainsight/settings', {
                  bucketPath: bucketPath,
                  accessKey: accessKey,
                  securityToken: securityToken
                });

              case 14:
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.bucketPath = bucketPath;
                updatedStoredState.accessKey = accessKey;
                updatedStoredState.securityToken = securityToken;
                this.setState({
                  isInstalled: true,
                  isExportEnabled: true,
                  messageType: 'success',
                  message: successMessage,
                  isSavingCredentials: false,
                  storedState: updatedStoredState
                });
                _context2.next = 31;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](11);
                data = _context2.t0.response.data;
                errorFields = [];

                if (!data.error) {
                  _context2.next = 30;
                  break;
                }

                if (data.error.includes('For security reasons access key should be at least 10 characters long')) {
                  errorFields.push({
                    field: 'accessKey',
                    message: 'Please enter a valid access key with at least 10 characters.'
                  });
                }

                if (data.error.includes('For security reasons token should be at least 10 characters long')) {
                  errorFields.push({
                    field: 'securityToken',
                    message: 'Please enter a valid security token with at least 10 characters.'
                  });
                }

                this.setState({
                  errorFields: errorFields,
                  isSavingCredentials: false
                });
                return _context2.abrupt("return");

              case 30:
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  isSavingCredentials: false
                });

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[11, 21]]);
      }));

      function onInstall() {
        return _onInstall.apply(this, arguments);
      }

      return onInstall;
    }()
  }, {
    key: "onUninstall",
    value: function () {
      var _onUninstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var successMessage, errorMessage, updatedStoredState;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                successMessage = "You've uninstalled Gainsight.";
                errorMessage = 'Sorry, something went wrong, please try again.';
                _context3.prev = 3;
                _context3.next = 6;
                return _axios.default.delete('/integration/gainsight/settings');

              case 6:
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.bucketPath = '';
                updatedStoredState.accessKey = '';
                updatedStoredState.securityToken = '';
                this.setState({
                  bucketPath: '',
                  accessKey: '',
                  securityToken: '',
                  isInstalled: false,
                  isExportEnabled: false,
                  messageType: 'success',
                  message: successMessage,
                  storedState: updatedStoredState,
                  showUninstallModal: false
                });
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](3);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showUninstallModal: false
                });

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 13]]);
      }));

      function onUninstall() {
        return _onUninstall.apply(this, arguments);
      }

      return onUninstall;
    }()
  }, {
    key: "setActiveTab",
    value: function setActiveTab(selectedTab) {
      if (this.checkPanelHasUnsavedChanges()) {
        this.setState({
          showUnsavedChangesModal: true,
          selectedTab: selectedTab
        });
        return;
      }

      this.setState({
        activeTab: selectedTab,
        selectedTab: selectedTab
      });
    }
  }, {
    key: "displayUnsavedChangedModal",
    value: function displayUnsavedChangedModal() {
      this.setState({
        showUnsavedChangesModal: true
      });
    }
  }, {
    key: "setSelectedPanel",
    value: function setSelectedPanel(selectedPanel) {
      this.setState({
        selectedPanel: selectedPanel
      });
    }
  }, {
    key: "removeValidationErrorFromInputField",
    value: function removeValidationErrorFromInputField(inputField) {
      var errorFields = this.state.errorFields;

      if ((errorFields === null || errorFields === void 0 ? void 0 : errorFields.length) === 0) {
        return;
      }

      var fields = errorFields === null || errorFields === void 0 ? void 0 : errorFields.filter(function (value) {
        return value.field !== inputField;
      });
      this.setState({
        errorFields: fields
      });
    }
  }, {
    key: "onResetInstallationTab",
    value: function onResetInstallationTab(activeTab) {
      this.setState({
        bucketPath: '',
        accessKey: '',
        securityToken: '',
        showUnsavedChangesModal: false,
        errorFields: [],
        activeTab: activeTab
      });
    }
  }, {
    key: "setActivePanel",
    value: function setActivePanel() {
      var selectedPanel = this.state.selectedPanel;
      this.setState({
        activePanel: selectedPanel
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state3 = this.state,
          isInstalled = _this$state3.isInstalled,
          messageType = _this$state3.messageType,
          message = _this$state3.message,
          activeTab = _this$state3.activeTab,
          showUninstallModal = _this$state3.showUninstallModal,
          showUnsavedChangesModal = _this$state3.showUnsavedChangesModal,
          bucketPath = _this$state3.bucketPath,
          accessKey = _this$state3.accessKey,
          securityToken = _this$state3.securityToken,
          errorFields = _this$state3.errorFields,
          isSavingCredentials = _this$state3.isSavingCredentials,
          isExportEnabled = _this$state3.isExportEnabled;
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = this.state.isExportEnabled ? 1 : 0;
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Gainsight",
        appLogoName: "gainsight-l",
        appContainerBackgroundColor: "#253F60",
        dismissMessage: this.dismissMessage,
        messageType: messageType,
        message: message,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: function onClickUninstallButton() {
            return _this3.onClickUninstallButton();
          }
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this3.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this3.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.IntegrationTab, {
          key: "integrationTab",
          isInstalled: isInstalled,
          isExportEnabled: isExportEnabled
        }), // @ts-expect-error Fix the TS issues in the next refactoring excercise
        (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          bucketPath: bucketPath,
          accessKey: accessKey,
          securityToken: securityToken,
          isInstalled: isInstalled,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this3.onInstall();

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          onCancel: function onCancel() {
            return _this3.onResetInstallationTab(1);
          },
          onClickManage: function onClickManage() {
            return _this3.setActiveTab(0);
          },
          onClickUninstall: function onClickUninstall() {
            return _this3.onClickUninstallButton();
          },
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this3.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this3.closeModal();
          },
          onChangeBucketAccessPathCallback: function onChangeBucketAccessPathCallback(value) {
            return _this3.setState({
              bucketPath: value
            });
          },
          onClickBucketAccessPathCallback: function onClickBucketAccessPathCallback() {
            return _this3.removeValidationErrorFromInputField('bucketAccessPath');
          },
          onChangeAccessKeyCallback: function onChangeAccessKeyCallback(value) {
            return _this3.setState({
              accessKey: value
            });
          },
          onClickAccessKeyCallback: function onClickAccessKeyCallback() {
            return _this3.removeValidationErrorFromInputField('accessKey');
          },
          onChangeSecurityTokenCallback: function onChangeSecurityTokenCallback(value) {
            return _this3.setState({
              securityToken: value
            });
          },
          onClickSecurityTokenCallback: function onClickSecurityTokenCallback() {
            return _this3.removeValidationErrorFromInputField('securityToken');
          },
          resetChanges: function resetChanges() {
            return _this3.onResetInstallationTab(0);
          },
          isSavingCredentials: isSavingCredentials,
          errorFields: errorFields
        })],
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "Salesforce",
          onUninstall: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            return _regenerator.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this3.onUninstall();

                  case 2:
                    return _context5.abrupt("return", _context5.sent);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          })),
          showUninstallModal: showUninstallModal,
          closeUninstallModal: function closeUninstallModal() {
            return _this3.closeUninstallModal();
          },
          enabledIntegrationCount: enabledIntegrationCount
        })
      });
    }
  }]);
  return GainsightIntegration;
}(_preact.Component);

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("div", null, (0, _preact.h)("div", null, "Gainsight helps customer success, post-sales, and product teams put customers at the heart of their business to deliver better outcomes and grow net dollar retention. Gainsight CS gives customer success teams a comprehensive 360 view of their customers and a holistic assessment of customer health."), (0, _preact.h)("div", {
    className: "description-details"
  }, "With the Gainsight connector, you can enable a 360 customer view and use community involvement as a top-level contributor for customer health scoring. You can also set up automated workflows in Journey Orchestrator to improve customer engagement, as well as report on activity trends in the context of your other customer data like renewals and ARR."), (0, _preact.h)("div", {
    className: "description-details"
  }, "This integration uses the Gainsight-managed S3 bucket and is intended for customers without Salesforce. If you use Salesforce, we recommend using our Salesforce integration as a data source in Gainsight for a simpler implementation."));
};

var _default = GainsightIntegration;
exports.default = _default;